"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../Schema/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FieldMedia extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", formData => {
      const _this$props = this.props,
            schema = _this$props.schema,
            defaultFormData = _this$props.defaultFormData;
      formData = (0, _utils.getDefaultFormState)(schema, _extends({}, defaultFormData, {}, formData));

      const newFormData = _extends({}, formData);

      console.log('FieldMedia:onChange', newFormData);

      if (this.props.onChange) {
        this.props.onChange(newFormData);
      }
    });

    _defineProperty(this, "onEditMedia", () => {
      const _this$props2 = this.props,
            id = _this$props2.id,
            schema = _this$props2.schema,
            uiSchema = _this$props2.uiSchema,
            formData = _this$props2.formData,
            formContext = _this$props2.formContext,
            onChange = _this$props2.onChange;

      if (formContext.onEditMedia) {
        formContext.onEditMedia({
          id: id,
          type: "media",
          schema: schema,
          uiSchema: uiSchema,
          formData: formData,
          onChange: onChange
        });
      }
    });

    _defineProperty(this, "onCropdata", imageCropdata => {
      const formData = this.props.formData;
      this.props.onChange(_extends({}, formData, {
        imageCropdata: imageCropdata
      }));
    });

    _defineProperty(this, "onFocalpoint", imageFocalpoint => {
      const formData = this.props.formData;
      this.props.onChange(_extends({}, formData, {
        imageFocalpoint: imageFocalpoint
      }));
    });

    _defineProperty(this, "onFilters", imageFilters => {
      const formData = this.props.formData;
      this.props.onChange(_extends({}, formData, {
        imageFilters: imageFilters
      }));
    });

    _defineProperty(this, "onAnnotations", imageAnnotations => {
      const formData = this.props.formData;
      this.props.onChange(_extends({}, formData, {
        imageAnnotations: imageAnnotations
      }));
    });

    _defineProperty(this, "getUiPreview", () => {
      return {
        "select": {
          "type": "type",

          /*
          "media": "media",
          "mediaId": "mediaId",
          "uploadProgress": "uploadProgress",
          "mediaId": "mediaId",
          "media": "media",
          "imageCropdata": "imageCropdata",
          "imageFocalpoint": "imageFocalpoint",
          "imageFilters": "imageFilters",
          "imageAnnotations": "imageAnnotations",
          "imageUrl": "imageUrl",
          */
          "title": "title",
          "status": "status"
        },

        prepare({
          formData
        }) {
          const title = formData.title,
                uniqueId = formData.uniqueId,
                imageUrl = formData.imageUrl,
                status = formData.status,
                mediaType = formData.mediaType,
                media = formData.media,
                mediaId = formData.mediaId,
                imageCropdata = formData.imageCropdata,
                imageFocalpoint = formData.imageFocalpoint,
                imageFilters = formData.imageFilters,
                imageAnnotations = formData.imageAnnotations;
          return {
            type: media && media.mediaType || mediaType,
            title: media && media.title || title,
            status: media && media.status || status
          };
          return {
            type: media && media.mediaType || mediaType,
            status: media && media.status || status,
            media: media,
            mediaId: mediaId || uniqueId,
            uploadProgress: media && media.uploadProgress,
            title: media && media.title || title,
            imageUrl: media && media.imageUrl || imageUrl,
            imageCropdata: imageCropdata,
            imageFocalpoint: imageFocalpoint,
            imageFilters: imageFilters,
            imageAnnotations: imageAnnotations
          };
        }

      };
    });

    _defineProperty(this, "getUiSchema", () => {
      const _this$props3 = this.props,
            formData = _this$props3.formData,
            schema = _this$props3.schema,
            uiSchema = _this$props3.uiSchema,
            defaultOptions = _this$props3.defaultOptions;
      let uiOptions = (0, _utils.getUiOptions)(uiSchema);
      let fieldset = uiOptions.fieldset || [];

      if (!uiOptions.fieldset && schema.properties) {
        Object.keys(schema.properties).map(name => {
          const type = schema.properties[name] && schema.properties[name].type || undefined;

          if (type === "object") {
            fieldset.push(name);
          }

          if (type === "array") {
            fieldset.push(name);
          }
        });
      }

      const mediaId = formData && formData.mediaId;
      const media = formData && formData.media;
      const uiMediaProps = {
        "ui:mediaId": mediaId,
        "ui:media": media,
        "ui:uploadProgress": media && media.uploadProgress,
        "ui:mediaType": media && media.mediaType,
        "ui:resources": media && media.resources,
        "ui:imageUrl": media && media.imageUrl,
        "ui:imageCropdata": formData && formData.imageCropdata,
        "ui:imageFocalpoint": formData && formData.imageFocalpoint,
        "ui:imageFilters": formData && formData.imageFilters,
        "ui:imageAnnotations": formData && formData.imageAnnotations
      };
      let uiMedia, uiCropdata, uiFocalpoint, uiFilters, uiAnnotations;

      if (fieldset && fieldset.includes('media')) {
        const uiSchemaMedia = uiSchema && uiSchema.media;
        uiMedia = _extends({
          "ui:title": "Preview",
          "ui:layout": "mediaPreview"
        }, uiMediaProps, {}, uiSchemaMedia);
      }

      if (fieldset && fieldset.includes('imageCropdata')) {
        const uiSchemaCropdata = uiSchema && uiSchema.imageCropdata;
        uiCropdata = _extends({
          "ui:title": "Crop",
          "ui:layout": "imageCropper",
          "ui:onChange": cropdata => this.onCropdata(cropdata)
        }, uiMediaProps, {}, uiSchemaCropdata);
      }

      if (fieldset && fieldset.includes('imageFocalpoint')) {
        const uiSchemaFocalpoint = uiSchema && uiSchema.imageFocalpoint;
        uiFocalpoint = _extends({
          "ui:title": "Focalpoint",
          "ui:layout": "imageFocalpoint",
          "ui:onChange": focalpoint => this.onFocalpoint(focalpoint)
        }, uiMediaProps, {}, uiSchemaFocalpoint);
      }

      if (fieldset && fieldset.includes('imageFilters')) {
        const uiSchemaFilters = uiSchema && uiSchema.imageFilters;
        uiFilters = _extends({
          "ui:title": "Filters",
          "ui:layout": "imageFilters",
          "ui:onChange": filters => this.onFilters(filters)
        }, uiMediaProps, {}, uiSchemaFilters);
      }

      if (fieldset && fieldset.includes('imageAnnotations')) {
        const uiSchemaAnnotations = uiSchema && uiSchema.imageAnnotations;
        uiAnnotations = _extends({
          "ui:title": "Annotations",
          "ui:layout": "imageAnnotations",
          "ui:onChange": annotations => this.onAnnotations(annotations)
        }, uiMediaProps, {}, uiSchemaAnnotations);
      }

      if (fieldset.length) {
        uiOptions.nav = fieldset.length > 1 && true;
        uiOptions.fieldset = fieldset;
      } // buttons


      let uiButtons = uiOptions.buttons || ["save"] || [];

      if (formData && formData.mediaId) {
        uiButtons = [...uiButtons, {
          label: "Edit media",
          onClick: this.onEditMedia
        }];
      } else {}
      /*
       uiButtons.push({
          label: "Edit media",
          disabled: "true"
      })
       */
      // getUiSettings

      /*
       let uiSettings;
       if (schema.properties.content && uiOptions.settings) {
           uiSettings = getUiSettings(({
              formData: formData && formData.content || {},
              schema: schema.properties.content,
              uiSchema: {
                  ...uiOptions.content,
                  "ui:settings": uiOptions.settings
              },
              onSettingsChange: this.onSettingsChange
          }))
       }
       */


      return _extends({}, uiSchema, {
        "ui:options": _extends({}, defaultOptions, {}, uiOptions)
      }, uiMediaProps, {
        "media": uiMedia,
        "imageCropdata": uiCropdata,
        "imageFocalpoint": uiFocalpoint,
        "imageFilters": uiFilters,
        "imageAnnotations": uiAnnotations,
        "ui:preview": this.getUiPreview(),
        "ui:buttons": uiButtons //            "ui:settings": uiSettings

      });
    });

    _defineProperty(this, "getField", () => {
      const uiSchema = this.getUiSchema();
      let _this$props4 = this.props,
          defaultFormData = _this$props4.defaultFormData,
          formData = _this$props4.formData,
          schema = _this$props4.schema;
      formData = (0, _utils.getDefaultFormState)(schema, _extends({}, defaultFormData, {}, formData));
      return _extends({}, this.props, {
        formData: formData,
        uiSchema: uiSchema
      });
    });
  }

  render() {
    const _this$getField = this.getField(),
          schema = _this$getField.schema,
          uiSchema = _this$getField.uiSchema,
          formData = _this$getField.formData,
          registry = _this$getField.registry;

    const ObjectField = registry.fields.ObjectField;
    return _react.default.createElement(ObjectField, _extends({}, this.props, {
      schema: schema,
      uiSchema: uiSchema,
      formData: formData,
      onChange: this.onChange
    }));
  }

}

_defineProperty(FieldMedia, "defaultProps", {
  defaultFormData: {
    "mediaId": undefined,
    "media": {
      "mediaType": undefined
    }
  },
  defaultOptions: {
    "layout": "media",
    "minHeight": 256,
    "editable": true,
    "deletable": true,
    "upload": true
  }
});

var _default = FieldMedia;
exports.default = _default;
module.exports = exports.default;